import Login from "../../../../jsx/pages/Customer/Login";

const LoginWrapper = function (props) {
    return (
        <Login />
    );
};

export default constore(LoginWrapper);